import { render, staticRenderFns } from "./CopySurveyDrawer.vue?vue&type=template&id=540333ad&scoped=true"
import script from "./CopySurveyDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./CopySurveyDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CopySurveyDrawer.vue?vue&type=style&index=0&id=540333ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "540333ad",
  null
  
)

export default component.exports